import React from 'react';
import styled from 'styled-components';
import { InputText } from 'primereact/inputtext';
import { Typography } from '../Typography';
import { InfoTooltip } from "../Tooltip/InfoTooltip";
import Copy from '../../assets/copy.svg'


interface InputProps {
  name: string;
  value: string;
  onChange: (e: any) => void;
  label?: string
  placeholder?: string
  tooltip?: React.ReactNode;
  className?: string;
}

export const Input: React.FC<InputProps> = props => {
  const { tooltip, className, ...other } = props;
  return (
    <Container className={className}>
      {props.label && (
        <Label>
          <Typography variant="body6">
            <label htmlFor={props.name}>{props.label}</label>
          </Typography>
          {tooltip && <InfoTooltip name={`input-tooltip-${props.name}`} tooltip={tooltip} />}
        </Label>
      )}
      <StyledInputText {...other} className={className} placeholder={props.placeholder} value={props.value} onChange={props.onChange} />
    </Container>
  );
}

const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
  flex: 1;
  width: 100%;
`;

const StyledInputText = styled(InputText)`
  border-radius: 10px;
`;

const Label = styled.div`
  display: flex;
  gap: 4px;
`;


